import React from 'react'
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { Button, Form, Input } from 'antd';
import type { FormProps } from 'antd';


type FieldType = {
  password?: string;
  newPassword?: string;
  checkPassword?: string;
};

const PasswordChange = () => {

  const onFinish: FormProps<FieldType>['onFinish'] = (values) => {
    console.log('Success:', values);
  };

  const onFinishFailed: FormProps<FieldType>['onFinishFailed'] = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <div className='bg-white rounded-xl p-4'>
      <label className='font-medium text-md text-gray-600'>Нууц үг солих</label>
      <div className='mt-4 max-w-[300px] passwordChangeForm'>
        <Form
          name="basic"
          style={{ maxWidth: 600 }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
        </Form>
        <Form.Item<FieldType>
          label="Нууц үг"
          name="password"
          className='!mb-2'
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <Input.Password
            placeholder="Одоо ашиглаж байгаа"
            iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
          />
        </Form.Item>
        <Form.Item<FieldType>
          label="Шинэ нууц үг"
          name="newPassword"
          className='!mb-2'
          rules={[{ required: true, message: 'Please input your newPassword!' }]}
        >
          <Input.Password
            placeholder="Шинэ нууц үг"
            iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
          />
        </Form.Item>
        <Form.Item<FieldType>
          label="Нууц үг давтах"
          name="checkPassword"
          rules={[{ required: true, message: 'Please input your checkPassword!' }]}
        >
          <Input.Password
            placeholder="Давтах"
            iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
          />
        </Form.Item>
        <Form.Item >
          <Button className='w-full' type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </div>
    </div>
  )
}

export default PasswordChange